import React from 'react';

import ArrowUp from '../../../assets/img/icons/arrow-up.svg';
import ArrowDown from '../../../assets/img/icons/arrow-down.svg';

const CTA = ({
    children,
    italic = false,
    arrowUp = false,
    arrowDown = false
}) => {
    const classList = ['cta'];

    if (italic) classList.push('Italic');

    return (
        <span
            className={classList.join(' ')}
        >
            {arrowUp && (<img className="up" style={{marginBottom: '10px'}} src={ArrowUp} alt="" />)}
            {children}
            {arrowDown && (<img className="down" style={{marginTop: '10px'}} src={ArrowDown} alt="" />)}
        </span>
    );
};

export default CTA;


// WEBPACK FOOTER //
// ./src/components/theme/CTA/CTA.jsx